<template>
  <div>
    <ReportPrintArticles :data="printData" :params="params" v-if="printData && params.type === 'ARTICLES'" />
    <ReportPrintDaily :data="printData" :params="params" v-if="printData && params.type === 'DAILY'" />
    <ReportPrintUsers :data="printData" :params="params" v-if="printData && params.type === 'USERS'" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    ReportPrintArticles: () => import('@/components/ReportPrintArticles'),
    ReportPrintDaily: () => import('@/components/ReportPrintDaily'),
    ReportPrintUsers: () => import('@/components/ReportPrintUsers')
  },
  data () {
    return {
      params: null,
      printData: null
    }
  },
  methods: {
    ...mapActions('reports', ['generateReport']),
    getParams () {
      return JSON.parse(this.$route.query.params)
    }
  },
  created () {
    this.params = this.getParams()
    this.generateReport(this.params)
      .then(response => {
        this.loading = false
        if (response) {
          this.printData = response
        }
      })
      .catch(anErr => {
        this.$notify({
          type: 'error',
          text: 'Prišlo je do napake pri generiranju izpisa.'
        })
      })
    this.$emit('ready')
  }
}
</script>
